<template>
    <div>
       
        <PrpFacelifting />
    </div>
</template>

<script>

import PrpFacelifting from '../../components/blog-details/PrpFacelifting'

export default {
    components: {
       
        PrpFacelifting,
    }
}
</script>